module.exports = __webpack_public_path__ + "static/media/glass3.f921121a.svg";